import { IShoppingCartState } from "interfaces/session/user-session-v3";
import { ISetShoppingCartStateAction } from "../interfaces/shopping-cart.interface";

export function setShoppingCartState(shoppingCartState: IShoppingCartState): ISetShoppingCartStateAction {
  return {
    type: "SET_SHOPPING_CART",
    data: shoppingCartState,
  };
}
